module.exports = __webpack_public_path__ + "img/2262570_s.fc8b1a44.jpg";